import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function CalendarChekIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M13.5 6.8h-11m11 1.5V6.08c0-1.008 0-1.512-.2-1.897a1.8 1.8 0 0 0-.801-.787c-.392-.196-.906-.196-1.932-.196H5.433c-1.026 0-1.54 0-1.932.196a1.8 1.8 0 0 0-.801.787c-.2.385-.2.889-.2 1.897v5.04c0 1.008 0 1.512.2 1.897.176.339.456.614.801.787.392.196.906.196 1.932.196H8m2.444-12v2.4M5.556 2v2.4m3.972 7.8 1.222 1.2 2.75-2.7" /></svg>
  );
}

export default CalendarChekIcon;
